export const InfiniteScrollActions = Object.freeze({
  ON_INFINITE_SCROLL: 'ON_INFINITE_SCROLL',
  ON_RANDOM_ACCESS_INFINITE_SCROLL: 'ON_RANDOM_ACCESS_INFINITE_SCROLL',
});
